import {readable, writable} from "svelte/store";
import {instantTranslate} from "../core/i18n/language-store.js";

export const orderConfigStore = readable(
    {},
    (set) => {
        set (M.ordersConfig || {enabled: false});
        return () => {}
    });

export const orderFormFieldsStore = readable(
    {},
    (set) => {
        set ({
            showNameField: !(M.ordersConfig.hideSystemFields || []).includes('name'),
            showPhoneField: !(M.ordersConfig.hideSystemFields || []).includes('phone'),
            showAddressField: !(M.ordersConfig.hideSystemFields || []).includes('address'),
            showCommentField: !(M.ordersConfig.hideSystemFields || []).includes('comment'),

            requireNameField: (M.ordersConfig.requiredSystemFields || []).includes('name'),
            requirePhoneField: (M.ordersConfig.requiredSystemFields || []).includes('phone'),
            requireAddressField: (M.ordersConfig.requiredSystemFields || []).includes('address'),
            requireCommentField: (M.ordersConfig.requiredSystemFields || []).includes('comment')
        });
        return () => {}
    });

export const deliveryStore = writable({}, (set) => {

    const selectedOnsite = M.ordersConfig.onsiteEnabled;
    const selectedDelivery = !selectedOnsite && M.ordersConfig.deliveryEnabled;
    const selectedPickup = !selectedOnsite && !selectedDelivery && M.ordersConfig.pickupEnabled;

    const selectedPickupPoint = (M.ordersConfig.pickupPoints || []).length === 1 ? M.ordersConfig.pickupPoints[0] : undefined;

    const options = [
        M.ordersConfig.onsiteEnabled,
        M.ordersConfig.deliveryEnabled,
        M.ordersConfig.pickupEnabled
    ];

    const showDeliveryOrPickupSelector = options.filter(Boolean).length > 1;

    set({
        selectedOnsite,
        selectedDelivery,
        selectedPickup,
        selectedPickupPoint,
        showDeliveryOrPickupSelector,
        showAcceptPolicy: true,
        deliveryRegion: null
    });

    return () => {}
});

export const selectDeliveryRegion = (deliveryRegion) => {
    deliveryStore.update(x => {
        x.deliveryRegion = deliveryRegion;
        return x;
    });
}

export const selectOnsite = () => {

    deliveryStore.update(x => {
        x.selectedOnsite = true;
        x.selectedDelivery = false;
        x.selectedPickup = false;
        return x;
    });
};

export const selectDelivery = () => {

    deliveryStore.update(x => {
        x.selectedOnsite = false;
        x.selectedDelivery = true;
        x.selectedPickup = false;
        return x;
    });
};

export const selectPickup = () => {

    deliveryStore.update(x => {
        x.selectedOnsite = false;
        x.selectedDelivery = false;
        x.selectedPickup = true;
        return x;
    });
};

export const selectPickupPoint = (point) => {

    if (point.enabled) {
        deliveryStore.update(x => {
            x.selectedPickupPoint = point;
            return x;
        });
    }
};

export const orderPlacementResultScreenStore = writable({
    orderNumber: undefined,
    error: undefined,
});

export const clearOrderPlacementResults = () => {
    orderPlacementResultScreenStore.update(x => {
        x.orderNumber = undefined;
        x.error = undefined;
        return x;
    });
}

export const setOrderPlacementResults = (data, error) => {
    orderPlacementResultScreenStore.update(x => {
        x.orderNumber = data?.orderNumber;
        x.error = error ? error.message || instantTranslate('common.unknownError') : undefined;
        x.errorStatus = error ? error.status : undefined;
        return x;
    });
}


export const additionalCostsStore = writable(
    {
        items: M.ordersConfig?.additionalCostsEnabled === true ? (M.ordersConfig.additionalCosts || []) : [],
        total: M.ordersConfig?.additionalCostsEnabled === true ? (M.ordersConfig.additionalCosts || []).reduce((a, b) => a + b.cost, 0) : 0
    },
    (set) => {

        const items = M.ordersConfig?.additionalCostsEnabled === true
            ? (M.ordersConfig.additionalCosts || [])
            : [];

        set({
            items,
            total: items.reduce((a, b) => a + b.cost, 0)
        });

        return () => {};
    });

export const removeAdditionalCost = (idx) => {

    additionalCostsStore.update(x => {
        x.items.splice(idx, 1);
        x.total = x.items.reduce((a, b) => a + b.cost, 0);
        return x;
    });
};

